'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var noop = function noop() {};

var topologySymbol = Symbol.for('@libp2p/js-interfaces/topology');
/**
 * @typedef {import('peer-id')} PeerId
 */

/**
 * @typedef {Object} Options
 * @property {number} [min=0] - minimum needed connections.
 * @property {number} [max=Infinity] - maximum needed connections.
 * @property {Handlers} [handlers]
 *
 * @typedef {Object} Handlers
 * @property {(peerId: PeerId, conn: Connection) => void} [onConnect] - protocol "onConnect" handler
 * @property {(peerId: PeerId, error?:Error) => void} [onDisconnect] - protocol "onDisconnect" handler
 *
 * @typedef {import('../connection/connection')} Connection
 */

var Topology = /*#__PURE__*/function (_Symbol$toStringTag) {
  /**
   * @param {Options} options
   */
  function Topology(_ref) {
    var _ref$min = _ref.min,
        min = _ref$min === void 0 ? 0 : _ref$min,
        _ref$max = _ref.max,
        max = _ref$max === void 0 ? Infinity : _ref$max,
        _ref$handlers = _ref.handlers,
        handlers = _ref$handlers === void 0 ? {} : _ref$handlers;

    _classCallCheck(this, Topology);

    this.min = min;
    this.max = max; // Handlers

    this._onConnect = handlers.onConnect || noop;
    this._onDisconnect = handlers.onDisconnect || noop;
    /**
     * Set of peers that support the protocol.
     *
     * @type {Set<string>}
     */

    this.peers = new Set();
  }

  _createClass(Topology, [{
    key: _Symbol$toStringTag,
    get: function get() {
      return 'Topology';
    }
  }, {
    key: topologySymbol,
    get: function get() {
      return true;
    }
    /**
     * Checks if the given value is a Topology instance.
     *
     * @param {any} other
     * @returns {other is Topology}
     */

  }, {
    key: "registrar",
    set:
    /**
     * @param {any} registrar
     */
    function set(registrar) {
      // eslint-disable-line
      this._registrar = registrar;
    }
    /**
     * Notify about peer disconnected event.
     *
     * @param {PeerId} peerId
     * @returns {void}
     */

  }, {
    key: "disconnect",
    value: function disconnect(peerId) {
      this._onDisconnect(peerId);
    }
  }], [{
    key: "isTopology",
    value: function isTopology(other) {
      return Boolean(other && other[topologySymbol]);
    }
  }]);

  return Topology;
}(Symbol.toStringTag);

module.exports = Topology;